export default __webpack_public_path__ + "static/we-are-g58-image-08ceb89b87bf663e5e1591a0a04ebbb1.jpg";